import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {UserManagementService} from "../../../../services/apiServices/business/user-management.service";
import {CommonService} from "../../../../services/apiServices/business/common.service";
import {BehaviorSubject, finalize} from "rxjs";
import {Unsubscribable} from "../../../mixin/unsubscribable.component";


@Component({
  selector: 'app-purge-config',
  templateUrl: './purge-config.component.html',
  styleUrls: ['./purge-config.component.css']
})
export class PurgeConfigComponent extends Unsubscribable(class {}) implements OnInit {

  public conf: bigint[];
  purgeConfLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private userManagementService : UserManagementService,
    private commonService : CommonService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.userManagementService.getPurgeConfig()
      .pipe(
        this.takeUntilDestroyed(),
        finalize(() => this.purgeConfLoading$.next(false))
      ).subscribe((purgeConfig:bigint[]) => {
        this.conf = purgeConfig
      });
    if(this.conf === null || this.conf.length < 2){
      this.conf[0] = BigInt(80);
      this.conf[1] = BigInt(3650);
    }
  }

  savePurgeConfig() {
    this.userManagementService.savePurgeConfig(this.conf)
      .pipe(
        this.takeUntilDestroyed(),
      ).subscribe(() => {
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.translateService.instant('PURGER_CONFIG.TOAST_TITLE'),
          detail: this.translateService.instant('PURGER_CONFIG.TOAST_CONTENT')
        });
      });
  }
}
